import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../utils/helpers/model.helper';
import { AccountUserRoleEnum } from './account-user-data.enum';

export const ACCOUNT_USER_SCHEMA = Object.freeze({
  ACCOUNT_ID: '',
  USER_ID: '',
  EMAIL: '',
  ROLE: AccountUserRoleEnum.invalid,
  CREATED_DATE: '', // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
});
const RECORD = generateSchema(ACCOUNT_USER_SCHEMA);
const KEYS: any = generateKeys(ACCOUNT_USER_SCHEMA);

export class AccountUser extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get accountId(): string {
    return this.get(KEYS.ACCOUNT_ID);
  }

  get userId(): string {
    return this.get(KEYS.USER_ID);
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get role(): AccountUserRoleEnum {
    return this.get(KEYS.ROLE);
  }

  get createDate(): string {
    return this.get(KEYS.CREATED_DATE);
  }

  isAccountOwner(ownerId: number): boolean {
    return ownerId.toString() === this.userId;
  }

  isLimited(): boolean {
    return this.role === AccountUserRoleEnum.limited_access;
  }

  serialize(): AccountUser {
    return this.toMap().withMutations((map) => {
      map.remove(KEYS.ACCOUNT_ID);
      map.remove(KEYS.CREATED_DATE);
    }) as AccountUser;
  }
}
